<form role="search" class="navbar-left app-search device-search pull-left m-r-10">
	<input type="text" id="js-device-search-term" placeholder="{{TR 'Suche...'}}" class="form-control">
	<a href="" id="js-device-search"><i class="fa fa-search"></i></a>
</form>
<li id="h-alarm" class="dropdown">
	<a aria-expanded="true" data-toggle="dropdown" class="dropdown-toggle m-r-5" href="">
		<i class="fa fa-bell"></i>
		<span class="badge badge-xs badge-danger js-alarm-count-badge">{{lastAlarmCount}}</span>
	</a>
	<ul id="alarm-menu" class="dropdown-menu alarm-menu multi-level js-alarm-top-list">
	</ul>
</li>
{{#IF_AVAILABLE 'status'}}
<li id="h-status" class="dropdown">
	<a aria-expanded="true" data-toggle="dropdown" class="dropdown-toggle" href="">
		<i id="js-device-summary" class="fa fa-circle error"></i> <span class="caret"></span>
	</a>
	<ul class="dropdown-menu status-menu">
		<li class="notifi-title">
			{{TR "Gerätestatus"}}
		</li>
		{{>STATUS_MENU_ENTRY status=status}}
	</ul>
</li>
{{/IF_AVAILABLE}}
<li id="h-profile" class="dropdown top-menu-item-xs">
	<a aria-expanded="true" data-toggle="dropdown" class="dropdown-toggle profile" href="">
		<i id="ct-user-menu" class="fa fa-user"></i><span class="caret"></span>
	</a>
	<ul id="js-main-menu" class="main-menu dropdown-menu multi-level">
		<li class="notifi-title m-b-10">
			{{name}}
		</li>
		{{>PROFILE_MENU_ENTRY profile=profile}}
	</ul>
</li>
